// ==============================|| OVERRIDES - TABLE CONTAINER ||============================== //
// Horizontal inset is applied via utils/tableInset (tableContainerInsetSx), not here,
// so tables inside padded scroll regions do not get double padding.

export default function TableContainer() {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          boxSizing: 'border-box'
        }
      }
    }
  };
}
